import AppBar from '@material-ui/core/AppBar'
import { withStyles } from '@material-ui/core/styles'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { selectCurrentOrganization } from '../../../../selectors/omnitecSelectors/omnitecOrganizations'
import { fetchOmnitecLocks } from '../../../../api/omnitecApi/omnitecLocks'
import {
    fetchOmnitecPrivateRooms,
    fetchOmnitecComonArea,
    deleteCommonMapping,
    deletePrivateMapping
} from '../../../../api/omnitecApi/omnitecRooms'
import { fetchOmnitecEasymsCategories } from '../../../../api/omnitecApi/omnitecEasyms'
import OrganizationTab from './OrganizationTab'
import CurrentOrganization from './CurrentOrganization'
import { selectLocks, selectLocksFetching } from '../../../../selectors/omnitecSelectors/omnitecLocks'
import {
    selectPrivateRooms,
    selectCommonArea,
    selectCommonAreaFetching,
    selectPrivateRoomsFetching
} from '../../../../selectors/omnitecSelectors/omnitecRooms'
import { selectEasymsCategories } from '../../../../selectors/omnitecSelectors/omnitecEasyms'
import LockTab from './LockTab'
import RoomsTab from './RoomsTab'
import EncodersTab from './EncodersTab/EncodersTab'

const TabContainer = props => (
    <Typography component="div" style={{ padding: 8 * 3, backgroundColor: '#f5f5f5' }}>
        {props.children}
    </Typography>
)

TabContainer.propTypes = {
    children: PropTypes.node.isRequired
}

const styles = theme => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper
    },
    tabs: {
        flex: 1
    },
    toolbarContent: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        width: '100%'
    },
    '@media (max-width: 720px)': {
        toolbarContent: {
            flexDirection: 'column',
            alignItems: 'center'
        }
    },
    typographyContainer: {
        padding: '50px 0',
        backgroundColor: '#f5f5f5'
    }
})

class MappingTabs extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired
    }

    state = { value: 0 }

    componentDidMount() {
        const { currentOrganization } = this.props
        if (currentOrganization) {
            this.props.fetchOmnitecPrivateRooms(currentOrganization)
            this.props.fetchOmnitecComonArea(currentOrganization)
            this.props.fetchOmnitecEasymsCategories(currentOrganization)
        }
    }

    componentDidUpdate(prevProps) {
        const { currentOrganization } = this.props
        if (prevProps.currentOrganization) {
            if (prevProps.currentOrganization !== currentOrganization) {
                this.props.fetchOmnitecPrivateRooms(currentOrganization)
                this.props.fetchOmnitecComonArea(currentOrganization)
                this.props.fetchOmnitecEasymsCategories(currentOrganization)
            }
        } else if (!prevProps.currentOrganization && !!currentOrganization) {
            this.props.fetchOmnitecPrivateRooms(currentOrganization)
            this.props.fetchOmnitecComonArea(currentOrganization)
            this.props.fetchOmnitecEasymsCategories(currentOrganization)
        }
    }

    handleChange = (event, value) => {
        this.setState({ value })
    }

    handleClickSearch = () => {
        const { currentOrganization } = this.props
        this.props.fetchOmnitecLocks(currentOrganization)
    }

    generateRoomInfoString = roomId => {
        const { easymsCategories } = this.props
        const data = easymsCategories
            .map(item => item.rooms)
            .reduce((prev, next) => prev.concat(next), [])
            .find(item => item.id === roomId)

        return data ? data.name : ''
    }

    generateCategoryInfoString = roomId => {
        const { easymsCategories } = this.props
        const data = easymsCategories.find(item => item.rooms.some(room => room.id === roomId))
        return data ? data.name : ''
    }

    render() {
        const { classes, currentOrganization } = this.props
        const { value } = this.state

        const { privateRooms, commonArea, easymsCategories, deleteCommonMapping, deletePrivateMapping } = this.props

        const privateRoomsList = privateRooms.map(item => ({
            ...item,
            roomInfo: this.generateCategoryInfoString(item.ourId) + ' / ' + this.generateRoomInfoString(item.ourId)
        }))

        return (
            <div className={classes.root}>
                <AppBar position="static" color="default">
                    <Toolbar>
                        <div className={classes.toolbarContent}>
                            <Tabs value={value} onChange={this.handleChange} className={classes.tabs}>
                                <Tab label="Организации" />
                                <Tab label="Замки" />
                                <Tab label="Приватные комнаты" />
                                <Tab label="Общедоступные комнаты" />
                                <Tab label="Энкодеры" />
                            </Tabs>
                            <CurrentOrganization />
                        </div>
                    </Toolbar>
                </AppBar>

                {value === 0 ? (
                    <TabContainer>
                        <OrganizationTab />
                    </TabContainer>
                ) : currentOrganization ? (
                    <Fragment>
                        {value === 1 && (
                            <TabContainer>
                                <LockTab
                                    fetching={this.props.fetching}
                                    locks={this.props.locks}
                                    handleClickSearch={this.handleClickSearch}
                                    privateRooms={privateRooms}
                                    commonArea={commonArea}
                                    easymsCategories={easymsCategories}
                                    currentOrganization={currentOrganization}
                                />
                            </TabContainer>
                        )}
                        {value === 2 && (
                            <TabContainer>
                                <RoomsTab
                                    rooms={privateRoomsList}
                                    fetching={this.props.privateRoomsFetching}
                                    onDelete={deletePrivateMapping}
                                    fields={[
                                        {
                                            label: 'ID замка',
                                            key: 'remoteId'
                                        },
                                        {
                                            label: 'Название замка',
                                            key: 'remoteName'
                                        },
                                        {
                                            label: 'Категория / комната',
                                            key: 'roomInfo'
                                        }
                                    ]}
                                />
                            </TabContainer>
                        )}
                        {value === 3 && (
                            <TabContainer>
                                <RoomsTab
                                    rooms={commonArea}
                                    fetching={this.props.commonAreaFetching}
                                    onDelete={deleteCommonMapping}
                                    fields={[
                                        {
                                            label: 'ID замка',
                                            key: 'remoteId'
                                        },
                                        {
                                            label: 'Название замка',
                                            key: 'remoteName'
                                        }
                                        // {
                                        //     label: 'ID организации EasyNS',
                                        //     key: 'organizationId'
                                        // }
                                    ]}
                                />
                            </TabContainer>
                        )}
                        {value === 4 && (
                            <TabContainer>
                                <EncodersTab />
                            </TabContainer>
                        )}
                    </Fragment>
                ) : (
                    <div className={classes.typographyContainer}>
                        <Typography variant="subheading" align="center">
                            Огранизация не выбрана. Пожалуйста, выберите организацию!
                        </Typography>
                    </div>
                )}
            </div>
        )
    }
}

export default connect(
    state => ({
        currentOrganization: selectCurrentOrganization(state),
        fetching: selectLocksFetching(state),
        locks: selectLocks(state),
        privateRooms: selectPrivateRooms(state),
        privateRoomsFetching: selectPrivateRoomsFetching(state),
        commonAreaFetching: selectCommonAreaFetching(state),
        commonArea: selectCommonArea(state),
        easymsCategories: selectEasymsCategories(state)
    }),
    {
        fetchOmnitecLocks,
        fetchOmnitecPrivateRooms,
        fetchOmnitecComonArea,
        fetchOmnitecEasymsCategories,
        deleteCommonMapping,
        deletePrivateMapping
    }
)(withStyles(styles)(MappingTabs))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/OmnitecTab/MappingTabs/MappingTabs.js